module.exports = __webpack_public_path__ + "img/DSC_2642-xl.9f3f34af.png";